// Actualización de LoadingProcess.jsx
import React from "react";
import { Box, Typography, CircularProgress } from '@mui/material';

const LoadingProcess = ({ text, tipo }) => {
    if (tipo === "mini") {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '5px',
                }}
            >
                <CircularProgress size={20} sx={{ color: '#0385ff' }} />
                <Typography variant="caption" sx={{ color: '#aaa', marginTop: 1 }}>
                    {text}
                </Typography>
            </Box>
        );
    }
    
    return (
        <Box
            sx={
                tipo === "area"
                ? { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }
                : {
                    minWidth: '400px',
                    maxWidth: '400px',
                    backgroundColor: '#111b21',
                    color: '#fff',
                    padding: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    position: 'fixed',
                    height: '100vh',
                }
            }
        >
            <CircularProgress />
            <Typography sx={{ color: '#fff', marginLeft: 2 }}>{text}</Typography>
        </Box>
    );
};

export default LoadingProcess;